export const BASE = "base";
export const MSURL = "ms";
